/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import axios from 'axios';
import '../../App.css';
import '../../bootstrap-5.2.3-dist/css/bootstrap.min.css';
import { Box, Container, TextField, Button, Card, CardContent, FormControl } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const PublicFigureForm = () => {
    const [name, setName] = useState('');
    const [bio, setBio] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [profession, setProfession] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [birthPlace, setBirthPlace] = useState('');
    const [nationality, setNationality] = useState('');
    const [knownFor, setKnownFor] = useState('');
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const publicFigure = {
            name,
            bio,
            imageUrl,
            occupation: profession,
            birthDate,
            birthPlace,
            nationality,
            knownFor
        };

        try {
            const response = await axios.post('/.netlify/functions/createPublicFigure', publicFigure);

            // Clear the form fields
            setName('');
            setBio('');
            setImageUrl('');
            setProfession('');
            setBirthDate('');
            setBirthPlace('');
            setNationality('');
            setKnownFor('');

            // Set the Snackbar message and open it
            setMessage('Public figure created successfully!');
            setOpen(true);
        } catch (error) {
            console.error('Error creating public figure', error);

            // Set the Snackbar message and open it
            setMessage('Error creating public figure');
            setOpen(true);
        }
    };

    return (
        <Container maxWidth="xs">
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                }}>
                <Card sx={{
                    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
                    backgroundColor: '#f2f2f2',
                    borderRadius: '15px',
                    border: '2px solid #FFFFFF00'
                }}>
                    <CardContent>
                        <h2 style={{
                            color:'#333333'
                        }}>Create Public Figure</h2>
                        <form onSubmit={handleSubmit}>
                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="name"
                                    label="Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="bio"
                                    label="Biography"
                                    value={bio}
                                    onChange={(e) => setBio(e.target.value)}
                                    multiline
                                    rows={4}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="imageUrl"
                                    label="Image URL"
                                    value={imageUrl}
                                    onChange={(e) => setImageUrl(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="profession"
                                    label="Profession"
                                    value={profession}
                                    onChange={(e) => setProfession(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="birthDate"
                                    label="Birth Date"
                                    type="date"
                                    value={birthDate}
                                    onChange={(e) => setBirthDate(e.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="birthPlace"
                                    label="Birth Place"
                                    value={birthPlace}
                                    onChange={(e) => setBirthPlace(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="nationality"
                                    label="Nationality"
                                    value={nationality}
                                    onChange={(e) => setNationality(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl
                                fullWidth
                                margin="normal"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#1c2734',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#16cc7d',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#15a2fa',
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: '#9ca3af'
                                    }
                                }}
                            >
                                <TextField
                                    id="knownFor"
                                    label="Known For"
                                    value={knownFor}
                                    onChange={(e) => setKnownFor(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#FFFFFF00',
                                        },
                                        '& .MuiInputBase-input': {
                                            color: '#9ca3af',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#9ca3af',
                                        },
                                    }}
                                />
                            </FormControl>
                            <Button
                                // fullWidth
                                width="50%"
                                type="submit"
                                color="primary"
                                variant="contained"
                                sx={{
                                    mt: 2,
                                    backgroundColor: '#15a2fa',
                                    '&:hover': {
                                        backgroundColor: '#FF005C',
                                    },
                                }}
                            >
                                Create Public Figure
                            </Button>
                        </form>

                    </CardContent>
                </Card>
            </Box>
            <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
                <Alert onClose={() => setOpen(false)} severity="success">
                    {message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default PublicFigureForm;
